// extracted by mini-css-extract-plugin
export var card = "_6m-0";
export var expandedCard = "_6m-2";
export var paginated = "_6m-1";